// extracted by mini-css-extract-plugin
export var active = "catalog-navigation-module--active--eH0Z1";
export var button = "catalog-navigation-module--button--f4NHl";
export var closed = "catalog-navigation-module--closed--lvKrR";
export var item = "catalog-navigation-module--item--qxh2B";
export var link = "catalog-navigation-module--link--r0lni";
export var linkBox = "catalog-navigation-module--link-box--XwAW8";
export var list = "catalog-navigation-module--list--tdJzx";
export var rotate = "catalog-navigation-module--rotate--kYiRA";
export var sublist = "catalog-navigation-module--sublist--WA7wJ";